export class InterfaceElementViewAreaTypes{
  public static readonly EntityListViewArea = "53b35db4-1f06-4691-a980-cb16e8a03199"; // fliegt weg
  public static readonly CosyMenuViewArea = "83872ffa-d978-46a2-9f2f-3c6561440cd6";
  public static readonly ViewArea1Type = "784dd3a6-33f5-4d4a-8dd1-cc505ea1ca09";
  public static readonly ViewArea2Type = "83872ffa-d978-46a2-9f2f-3c6561440cd6";
  public static readonly ViewArea3Type = "29367f65-d00d-450b-8c89-29ac330ad086";
  public static readonly ViewArea4Type = "53b35db4-1f06-4691-a980-cb16e8a03199";
}
